import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

const faqs = [
  {
    q: '¿Es obligatorio el registro horario en mi empresa?',
    a: 'Sí. Desde el 12 de mayo de 2019 (Real Decreto-ley 8/2019), todas las empresas en España deben registrar diariamente la jornada de cada trabajador, sea cual sea su tamaño o sector. No hacerlo puede suponer multas de hasta 7.500 € por centro de trabajo.',
  },
  {
    q: '¿Qué cambia con la nueva normativa de control horario de 2026?',
    a: 'El Gobierno está tramitando un nuevo Real Decreto que hará obligatorio el registro digital de jornada: el papel y el Excel dejarán de ser válidos. Además, las multas pasarán a calcularse por trabajador afectado (de 1.000 a 10.000 €) y la Inspección de Trabajo podrá acceder a los registros de forma remota. GestionaEmpleados ya cumple con todos estos requisitos, así que si empiezas hoy, el cambio de normativa no te afectará.',
  },
  {
    q: '¿Qué incluye la prueba gratis de 15 días?',
    a: 'Absolutamente todo: tablet kiosko, app móvil con GPS, informes, calendario laboral, turnos... Sin tarjeta de crédito y sin permanencia. Si al acabar no quieres continuar, no pagas nada.',
  },
  {
    q: '¿Cómo fichan mis empleados?',
    a: 'Como mejor le venga a tu empresa, siempre con métodos 100% digitales y válidos según la nueva normativa: desde una tablet o un ordenador compartido en modo kiosko (tocan su nombre e introducen su PIN) o desde su propio móvil con la app del empleado, que valida su ubicación GPS y permite entrar con la huella o Face ID. Tú decides qué empleados pueden usar cada método.',
  },
  {
    q: '¿Necesito instalar algo o comprar hardware?',
    a: 'No. GestionaEmpleados funciona en el navegador de cualquier tablet, móvil u ordenador. Te sirve cualquier tablet Android o iPad que ya tengas para el modo kiosko.',
  },
  {
    q: '¿Puedo corregir un fichaje si alguien se olvida de fichar?',
    a: 'Sí, y de forma legal: cuando el administrador crea o modifica un fichaje manualmente, el empleado recibe la solicitud y debe aprobarla en su próximo fichaje. Todo queda registrado en la auditoría, tal y como exige la normativa.',
  },
  {
    q: '¿Me sirve para una inspección de trabajo?',
    a: 'Sí. Puedes exportar en segundos un informe en PDF o Excel con los fichajes diarios, horas trabajadas, horas extra y nocturnas de cualquier periodo. Incluso puedes generar el informe específico de "Cumplimiento legal" que analiza descansos, jornada máxima y nocturnidad según los artículos 34-38 del Estatuto de los Trabajadores. Los registros se conservan de forma segura durante los 4 años que marca la ley.',
  },
  {
    q: '¿Qué informes genera GestionaEmpleados?',
    a: 'Seis tipos, todos exportables a PDF con tu marca y a Excel multi-hoja: (1) Detallado día a día, (2) Resumen ejecutivo con KPIs para dirección, (3) Análisis de horas extra y déficit, (4) Absentismo, (5) Cumplimiento legal (RD-Ley 8/2019 + art. 34-38 ET), y (6) Productividad por departamento. Además, tenemos un informe específico de nocturnidad que detecta automáticamente quién califica como "trabajador nocturno" según el art. 36 ET.',
  },
  {
    q: '¿Puedo enviar los informes automáticamente a mi gestoría?',
    a: 'Sí, y en pocos segundos: configuras el tipo de informe, los destinatarios (tu gestoría, RRHH, dirección, quien quieras), la periodicidad (semanal o mensual) y el día/hora de envío. El sistema genera el informe del periodo correspondiente y lo envía por email en PDF, Excel o ambos. Un cliente típico programa un envío mensual el día 1 al asesor laboral y otro semanal a RRHH los lunes.',
  },
  {
    q: '¿Y si un empleado se olvida de fichar la salida?',
    a: 'No pasa nada, y sin roces. Nuestro autocierre inteligente cierra automáticamente la jornada según el horario configurado del empleado (que puede ser genérico, distinto por cada día de la semana, o heredado del centro o departamento). Cuando el empleado vuelve a la app, ve el cierre pendiente y lo tiene que aceptar (o proponer una corrección). Así cumples la nueva normativa 2026: toda corrección debe estar validada por el trabajador.',
  },
  {
    q: '¿Cómo gestiono turnos rotativos?',
    a: 'Con el cuadrante semanal: una vista tipo hoja de cálculo con tus empleados en filas y los 7 días en columnas. Asignas turnos con un click. Cuando quieres avanzar al siguiente periodo, pulsas "Copiar semana" o "Rotar" para aplicar una rotación circular entre empleados. Ideal para hostelería, sanidad, retail o cualquier equipo con turnos alternos.',
  },
  {
    q: '¿Qué pasa con la protección de datos (RGPD)?',
    a: 'Solo tratamos los datos imprescindibles para el registro de jornada. La geolocalización se comprueba únicamente en el momento del fichaje desde la app, nunca hay seguimiento continuo, y no se usan sistemas invasivos como fotos o biometría.',
  },
  {
    q: '¿Puedo cancelar cuando quiera?',
    a: 'Sí. No hay permanencia ni penalizaciones. Puedes exportar todos tus datos antes de irte.',
  },
];

export const FaqSection = () => (
  <section id="faq" className="py-20 sm:py-28 bg-forest-100/50" data-testid="faq-section">
    <div className="max-w-3xl mx-auto px-5 sm:px-8">
      <div className="mb-12">
        <p className="font-body-landing text-terracotta font-bold text-sm tracking-[0.15em] uppercase mb-4">Preguntas frecuentes</p>
        <h2 className="font-display font-black text-forest-900 text-3xl sm:text-4xl leading-tight tracking-tight">
          Resolvemos tus dudas
        </h2>
      </div>
      <Accordion type="single" collapsible className="space-y-3">
        {faqs.map((f, i) => (
          <AccordionItem key={i} value={`faq-${i}`} className="rounded-2xl border border-forest-900/10 bg-white px-6 data-[state=open]:shadow-[0_8px_30px_rgb(0,0,0,0.05)]" data-testid={`faq-item-${i}`}>
            <AccordionTrigger className="font-body-landing font-bold text-forest-900 text-left text-sm sm:text-base hover:no-underline py-5">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="font-body-landing text-forest-700 text-sm leading-relaxed pb-5">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
